module.exports = __webpack_public_path__ + "img/governor.3d03669d.png";